import gql from 'graphql-tag'

export const CONTACT_QUERY = gql`
query {
  contact {
    data {
      attributes {
        intro {
          Intro {
            Title
            Caption
            Description
          }
        }
        seo {
          metaTitle
          metaDescription
          metaImage {
            data {
              attributes {
                url
                alternativeText
                formats
              }
            }
          }
          metaSocial {
            socialNetwork
            title
            description
            image {
              data {
                attributes {
                  url
                  alternativeText
                  formats
                }
              }
            }
          }
        }
      }
    }
  }
}

`;
